import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import User from './modules/user'
import App from './modules/app'
import Admin from './modules/admin'
import Plussvr from './modules/plussvr'
import getters from './getters'

Vue.use(Vuex)

const store: StoreOptions<any> = {
  modules: {
    User,
    App,
    Admin,
    Plussvr
  },
  getters
}

export default new Vuex.Store<any>(store)
